import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-037fc65f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "app-container"
};
const _hoisted_2 = {
  class: "search-container"
};
const _hoisted_3 = {
  class: "search-left"
};
const _hoisted_4 = {
  class: "table-container-wrapper"
};
const _hoisted_5 = {
  class: "table-top-flex"
};
const _hoisted_6 = {
  class: "table-title"
};
const _hoisted_7 = {
  class: "history-records-container"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "history-title"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-time",
  style: {
    "margin-right": "8px"
  }
}), /*#__PURE__*/_createTextVNode(" 历史处理记录 ")], -1));
const _hoisted_9 = {
  class: "records-list"
};
const _hoisted_10 = {
  class: "record-header"
};
const _hoisted_11 = {
  class: "record-time"
};
const _hoisted_12 = {
  class: "record-operator"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "operator-label"
}, "处理人：", -1));
const _hoisted_14 = {
  class: "operator-name"
};
const _hoisted_15 = {
  class: "record-content"
};
const _hoisted_16 = {
  class: "record-item"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "item-label"
}, "处理结果:", -1));
const _hoisted_18 = {
  class: "item-value"
};
const _hoisted_19 = {
  class: "record-item"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "item-label"
}, "处理意见:", -1));
const _hoisted_21 = {
  class: "item-value"
};
const _hoisted_22 = {
  key: 0,
  class: "record-images"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "item-label"
}, "现场图片:", -1));
const _hoisted_24 = {
  class: "images-grid"
};
const _hoisted_25 = {
  class: "dialog-footer"
};
import { reactive, watch, ref, onMounted, nextTick, computed, unref } from "vue";
import { useRoute } from "vue-router";
import { weChatrequest } from '@/utils/request';
import { useStore } from "vuex";
import { ElMessage, ElMessageBox } from 'element-plus';
import { download } from "@/utils/index";

// 接收父组件传递的deviceCode

const __default__ = {
  name: "alarm-monitor-real"
};
export default /*#__PURE__*/Object.assign(__default__, {
  props: {
    deviceCode: {
      type: String,
      default: ''
    }
  },
  setup(__props) {
    const props = __props;
    const store = useStore();
    // 获取用户类型

    // 表格标题
    const tableTitle = computed(() => {
      return '实时告警';
    });
    const userType = store.state.common.userInfo.userType;
    const route = useRoute();
    let warnForm = ref(null);
    // 获取图片URL前缀
    const getImgUrl = url => {
      if (!url) return '';
      const prefix = window.g?.imgUrlPrex || '';
      return prefix + url;
    };
    const state = reactive({
      split: 0.13,
      openDataScope: false,
      saveLoading: false,
      defaultProps: {
        label: "name",
        children: "children"
      },
      treeData: [],
      defaultCheckNode: [],
      defaultExendNode: [],
      currentNodeKey: '',
      tableData: {
        rows: [],
        total: 0
      },
      buttonsList: [{
        buttonName: "导出",
        buttonStyle: "warning",
        hasPermi: ['alarm:page:export'],
        className: 'exportBtn',
        buttonIcon: "Upload",
        exp: item => handleExport(item)
      }],
      form: {
        id: "",
        treatResult: "",
        treatOpinion: "",
        imgUrl: "",
        historyRecords: []
      },
      rules: {
        treatResult: [{
          required: true,
          message: '不能为空',
          trigger: 'change'
        }],
        treatOpinion: [{
          required: true,
          message: '不能为空',
          trigger: 'blur'
        }, {
          max: 20,
          message: '处理意见最多500个字符',
          trigger: 'blur'
        }]
      },
      options: [{
        value: 1,
        label: '处理中'
      }, {
        value: 2,
        label: '延期处理'
      }, {
        value: 3,
        label: '已解决'
      }]
    });
    let queryParams = reactive({
      pageNum: 1,
      // 当前页数
      pageSize: 10,
      //  每页数目
      deviceCode: "",
      menuTypes: [],
      tenantId: null
    });
    const searchFormData = ref([{
      prop: "deviceCode",
      label: "设备编号",
      placeholder: "请输入设备编号",
      type: "text",
      span: 4
    }
    // {
    //   prop: "menuTypes",
    //   label: "设备类型",
    //   placeholder: "请选择设备类型",
    //   type: "list",
    //   span: 4,
    //   isSelect: false,
    //   filterable: true,
    //   multiple: true,
    //   options: [
    //     { label: "执行器", value: 1 },
    //     { label: "场站泄漏", value: 2 },
    //     { label: "阀井泄漏", value: 3 },
    //     { label: "管钉泄漏", value: 4 },
    //     { label: "管桩泄漏", value: 5 },
    //     { label: "压力监测", value: 6 },
    //     { label: "工商业报警", value: 7 },
    //   ],
    //   props: { label: 'label', value: 'value' },
    // },
    ]);
    let loading = ref(false);
    // 取消按钮（数据权限）
    const cancelDataScope = function () {
      state.openDataScope = false;
      reset();
    };
    const clearValidate = prop => {
      warnForm.value.clearValidate(prop);
    };
    /** 提交按钮*/
    const submitDataScope = function () {
      const formRef = unref(warnForm);
      formRef.validate(valid => {
        if (valid) {
          state.saveLoading = true;
          let params = {
            ...state.form
          };
          params.alarmId = state.form.id;
          if (state.form.imgUrl && Array.isArray(state.form.imgUrl) && state.form.imgUrl.length > 0) {
            params.imgUrl = state.form.imgUrl.join(',');
          } else {
            params.imgUrl = '';
          }
          console.log(params, 'params====');
          weChatrequest({
            url: '/api/v1/alarm/resolution/submit',
            method: 'post',
            data: params
          }).then(response => {
            if (response.code == 0) {
              ElMessage.success('处理成功');
              state.openDataScope = false;
              reset();
              getList();
            } else {
              ElMessage.error(response.msg || '处理失败');
            }
            state.saveLoading = false;
          }).catch(() => {
            state.saveLoading = false;
          });
        }
      });
    };
    const getList = () => {
      loading.value = true;
      weChatrequest({
        url: '/api/v1/alarm/ledger/realtime',
        method: 'post',
        data: queryParams
      }).then(res => {
        if (res.code == 0) {
          state.tableData.rows = res.data.records;
          state.tableData.total = res.data.total;
        }
      }).finally(() => {
        loading.value = false;
      });
    };
    const reset = () => {
      state.form.id = '';
      state.form.treatResult = '';
      state.form.treatOpinion = '';
      state.form.imgUrl = '';
      state.form.historyRecords = [];
    };
    const resetQuery = () => {
      queryParams.deviceCode = '';
      queryParams.menuTypes = null;
      queryParams.pageNum = 1;
      getList();
    };
    const formHandle = [{
      label: "搜索",
      type: "primary",
      class: "btn-liquid",
      icon: "el-icon-search",
      handle: () => getList()
    }, {
      label: "重置",
      icon: "el-icon-refresh",
      class: "commonDarkBtn",
      handle: () => resetQuery()
    }];
    const tableHeader = [{
      prop: "deviceCode",
      label: "设备编号",
      fixed: false,
      type: "text"
    },
    // {
    //   prop: "alarmTime",
    //   label: "告警时间",
    //   fixed: false,
    //   type: "text",
    // },
    {
      prop: "alarmContent",
      label: "告警内容",
      fixed: false,
      type: "text"
    },
    // {
    //   prop: "menuType",
    //   label: "设备类型",
    //   statusList: [{
    //     value: 1,
    //     label: "执行器",
    //   },{
    //     value: 2,
    //     label: "场站泄漏",
    //   },
    //   {
    //     value: 3,
    //     label: "阀井泄漏",
    //   },
    //   {
    //     value: 4,
    //     label: "管钉泄漏",
    //   },
    //   {
    //     value: 5,
    //     label: "管桩泄漏",
    //   }, {
    //     value: 6,
    //     label: "压力监测",
    //   }, {
    //     value: 7,
    //     label: "工商业报警",
    //   },
    //   ],
    // },
    {
      prop: "severity",
      label: "严重程度",
      statusList: [{
        value: 1,
        label: "致命"
      }, {
        value: 2,
        label: "严重"
      }, {
        value: 3,
        label: "一般"
      }, {
        value: 4,
        label: "提示"
      }]
    }, {
      prop: "firstAlarmTime",
      label: "初次告警时间",
      fixed: false,
      type: "text"
    }, {
      prop: "lastOccurTime",
      label: "最后告警时间",
      fixed: false,
      type: "text"
    }, {
      prop: "occurCnt",
      label: "告警次数",
      fixed: false,
      type: "text"
    }, {
      prop: "recovered",
      label: "消缺状态",
      fixed: false,
      statusList: [{
        value: 0,
        label: "未恢复"
      }, {
        value: 1,
        label: "已恢复待确认"
      }]
    }, {
      prop: "recoveredTime",
      label: "消缺时间",
      fixed: false,
      type: "text"
    }, {
      prop: "operation",
      label: "操作",
      width: "80px",
      fixed: 'right',
      operation: [{
        name: '处理告警',
        clickFun: row => handleOperate(row),
        hasPermi: ["alarm:realtime:handle"]
        // disabledHandle(row) {
        //   return !row.needManualConfirm;//0不需要人工确认 1需要人工确认
        // },
      }]
    }
    // {
    //   prop: "deviceAddress",
    //   label: "安装位置",
    //   fixed: false,
    //   type: "text",
    // }
    ];
    const handleNodeClick = params => {
      nextTick(() => {
        state.defaultCheckNode = [params];
      });
      state.currentNodeKey = params.id;
      getList();
    };
    // 处理
    const handleOperate = async row => {
      reset();
      state.form.id = row.id;
      // 查询是否有处理记录
      if (row.id) {
        const response = await weChatrequest({
          url: '/api/v1/alarm/resolution/list',
          method: 'get',
          params: {
            alarmId: row.id,
            alarmType: 0 // 0-实时告警；1-历史告警
          }
        });
        if (response.code == 0) {
          // 保存所有历史记录
          state.form.historyRecords = response.data;
        }
      }
      state.openDataScope = true;
    };
    const handleExport = function () {
      ElMessageBox.close();
      ElMessageBox.confirm('是否确认导出数据?', "导出", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        let params = {
          ...queryParams
        };
        weChatrequest({
          url: '/api/v1/alarm/ledger/realtime/export',
          method: 'post',
          data: params,
          responseType: 'blob'
        }).then(res => {
          if (res.status === 200) {
            let fileName = decodeURI(res.headers["content-disposition"].split("utf-8''")[1]);
            download(res.data, fileName);
          }
        }).catch(() => {});
      });
    };
    onMounted(async () => {
      // 如果有传入的deviceCode，自动填充到搜索框
      if (props.deviceCode) {
        queryParams.deviceCode = props.deviceCode;
      }

      // 如果是用户类型3，加载树形数据
      if (userType == 3) {
        state.loading = true;
        weChatrequest({
          url: '/api/v1/sysArea/findTree',
          method: "get"
        }).then(res => {
          state.treeData = [res.data];
          if (state.treeData[0]?.children) {
            state.defaultExendNode = state.treeData[0].children[0].id;
          }
          state.loading = false;
        }).catch(() => {
          state.loading = false;
        });
      }

      // 自动调用搜索
      getList();
    });
    return (_ctx, _cache) => {
      const _component_commonForm = _resolveComponent("commonForm");
      const _component_Iconfont = _resolveComponent("Iconfont");
      const _component_commonTable = _resolveComponent("commonTable");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input = _resolveComponent("el-input");
      const _component_EIUploadMutiplePic = _resolveComponent("EIUploadMutiplePic");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_commonDrawer = _resolveComponent("commonDrawer");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_commonForm, {
        form: _unref(queryParams),
        formData: searchFormData.value,
        showLabel: true,
        formHandle: formHandle
      }, null, 8, ["form", "formData"])])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_Iconfont, {
        name: "zhihui-gaojingjiance1",
        class: "table-title-icon"
      }), _createElementVNode("p", null, _toDisplayString(_unref(tableTitle)), 1)])]), _withDirectives(_createVNode(_component_commonTable, {
        size: "medium",
        ref: "tableContainer",
        style: {
          "clear": "both"
        },
        hasStripe: false,
        hasSelect: false,
        tableData: state.tableData,
        multipleSelection: state.multipleSelection,
        "onUpdate:multipleSelection": _cache[0] || (_cache[0] = $event => state.multipleSelection = $event),
        tableHeader: tableHeader,
        queryParams: _unref(queryParams),
        onGetList: getList
      }, null, 8, ["tableData", "multipleSelection", "queryParams"]), [[_directive_loading, _unref(loading)]])]), _createVNode(_component_commonDrawer, {
        modelValue: state.openDataScope,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => state.openDataScope = $event),
        size: "550px",
        title: "处理告警",
        "close-on-click-modal": false,
        onClose: cancelDataScope
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_25, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submitDataScope,
          loading: _ctx.saveLoading
        }, {
          default: _withCtx(() => [_createTextVNode("确 定")]),
          _: 1
        }, 8, ["loading"]), _createVNode(_component_el_button, {
          onClick: cancelDataScope
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_form, {
          model: state.form,
          "status-icon": "",
          "label-width": "120px",
          ref_key: "warnForm",
          ref: warnForm,
          rules: state.rules,
          class: "commonForm",
          "label-position": "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            gutter: 15
          }, {
            default: _withCtx(() => [state.form.historyRecords.length > 0 ? (_openBlock(), _createBlock(_component_el_col, {
              key: 0,
              span: 24
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.form.historyRecords, (record, index) => {
                return _openBlock(), _createElementBlock("div", {
                  key: record.id,
                  class: "record-card"
                }, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, " 处理时间：" + _toDisplayString(record.createTime), 1), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("span", _hoisted_14, _toDisplayString(record.createName || '-'), 1)])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("span", _hoisted_18, _toDisplayString(record.treatResultName), 1)]), _createElementVNode("div", _hoisted_19, [_hoisted_20, _createElementVNode("span", _hoisted_21, _toDisplayString(record.treatOpinion), 1)]), record.imgUrl ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_hoisted_23, _createElementVNode("div", _hoisted_24, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.imgUrl.split(','), (img, imgIndex) => {
                  return _openBlock(), _createBlock(_component_el_image, {
                    key: imgIndex,
                    src: getImgUrl(img),
                    "zoom-rate": 1.2,
                    "preview-src-list": record.imgUrl.split(',').map(url => getImgUrl(url)),
                    "initial-index": imgIndex,
                    fit: "cover",
                    class: "preview-img",
                    "preview-teleported": ""
                  }, null, 8, ["src", "zoom-rate", "preview-src-list", "initial-index"]);
                }), 128))])])) : _createCommentVNode("", true)])]);
              }), 128))])])]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "处理结果",
                prop: "treatResult"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: state.form.treatResult,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => state.form.treatResult = $event),
                  placeholder: ""
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.options, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "处理意见",
                prop: "treatOpinion"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.treatOpinion,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => state.form.treatOpinion = $event),
                  placeholder: "请输入处理意见最多200个字符",
                  type: "textarea",
                  rows: 3,
                  maxlength: "500",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "现场图片",
                prop: "imgUrl"
              }, {
                default: _withCtx(() => [_createVNode(_component_EIUploadMutiplePic, {
                  "file-list": state.form.imgUrl,
                  "onUpdate:fileList": _cache[3] || (_cache[3] = $event => state.form.imgUrl = $event),
                  limit: 3,
                  onClearValidate: _cache[4] || (_cache[4] = $event => clearValidate(state.form.imgUrl)),
                  uploadTip: "最多上传3张图片"
                }, null, 8, ["file-list"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});